import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from 'primeng/dropdown';

import { HeadquarterSelectComponent } from './headquarter-select/headquarter-select.component';
import { LocationSelectComponent } from './location-select/location-select.component';
import { BookingTypeSelectComponent } from './booking-type-select/booking-type-select.component';
import { LicenseTypeSelectComponent } from './license-type-select/license-type-select.component';
import { TimezoneSelectComponent } from './timezone-select/timezone-select.component';
import { CultureInfoSelectComponent } from './culture-info-select/culture-info-select.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    DropdownModule,
    HeadquarterSelectComponent,
    LocationSelectComponent,
    BookingTypeSelectComponent,
    LicenseTypeSelectComponent,
    TimezoneSelectComponent,
    CultureInfoSelectComponent
  ],
  exports: [
    HeadquarterSelectComponent,
    LocationSelectComponent,
    BookingTypeSelectComponent,
    LicenseTypeSelectComponent,
    TimezoneSelectComponent,
    CultureInfoSelectComponent
  ]
})
export class SelectModule { } 